export type AssistantAccessConfig = {
  assistantIds: string[] | null;
  defaultAssistantId: string | null;
};

const hasOnlyStringValues = (value: unknown): value is string[] => {
  return Array.isArray(value) && value.every((item) => typeof item === "string");
};

export const parseAssistantAccessConfig = (
  payload: unknown
): AssistantAccessConfig | null => {
  if (typeof payload === "string") {
    try {
      return parseAssistantAccessConfig(JSON.parse(payload));
    } catch {
      return null;
    }
  }

  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return null;
  }

  const assistantIdsValue = Reflect.get(payload, "assistantIds");
  const defaultAssistantIdValue = Reflect.get(payload, "defaultAssistantId");

  const assistantIds =
    assistantIdsValue === null || assistantIdsValue === undefined
      ? null
      : hasOnlyStringValues(assistantIdsValue)
        ? assistantIdsValue
        : undefined;

  if (assistantIds === undefined) {
    return null;
  }

  const defaultAssistantId =
    defaultAssistantIdValue === null || defaultAssistantIdValue === undefined
      ? null
      : typeof defaultAssistantIdValue === "string"
        ? defaultAssistantIdValue
        : undefined;

  if (defaultAssistantId === undefined) {
    return null;
  }

  if (
    defaultAssistantId &&
    assistantIds !== null &&
    !assistantIds.includes(defaultAssistantId)
  ) {
    return null;
  }

  return {
    assistantIds,
    defaultAssistantId,
  };
};
